//import * as base from 'utils/bolt/dynamicData.js';
export * from 'utils/bolt/dynamicData.js';
import Store from 'store/store';
import formatDateTime from 'utils/formatDateTime';

const youtubeVideoRegex = /(?:youtube(?:-nocookie)?\.com\/(?:watch.*[?&]v=|(?:v|embed|watch|shorts|live|e)\/)|youtu\.be\/)([0-9a-z_-]+)(?:[?&#]|$)/i;
function getYoutubeId(url) {
	if (!url || typeof url !== 'string') return null;
	const match = url.match(youtubeVideoRegex);
	return match?.slice(1).find(Boolean) || null;
}

const vimeoVideoRegex = /vimeo\.com\/([^/?#&]+)(?:(?:\/|\?h=)([^/?#&]+))?/;
function getVimeoId(url) {
	if (!url || typeof url !== 'string') return null;
	const match = url.match(vimeoVideoRegex);
	return match?.[1] ? { vimeoId: match[1], vimeoHash: match[2] } : null;
}



function getHeroButton(data, button) {
	if (!button) return;
	let link = button.link;
	let label = button.label;
	if (link === '#tickets' && data.watch?.showShowtimes) {
		link = `${data.url}-showtimes`;
	}
	if (link === '#homeEnt' && data.watch?.showHomeEnt) {
		link = `${data.url}-homeEnt`;
	}
	if (button.autoTickets) {
		label = null;
		link = null;
		const today = formatDateTime(new Date(), 'yyyy-MM-dd');
		const date = data?.dates?.boxOffice || data?.dates?.release;
		if (date) {
			if (today < date) {
				label = 'Save to Calendar';
				link = `@calendarreminder::${date}`;
			} else if (data?.watch?.showShowtimes) {
				label = 'Get Tickets';
				link = `${data.url}-showtimes`;
			}
		}
	}
	return { label, link };
}

export function transformPageData(data) {
	const appData = Store.get().appData;

	const vimeoData = getVimeoId(data.hero?.trailer);
	const youtubeId = !vimeoData && getYoutubeId(data.hero?.trailer);
	let trailer;
	if (vimeoData) {
		trailer = vimeoData;
	} else if (youtubeId) {
		trailer = { youtubeId, thumbSrc: `https://i.ytimg.com/vi/${youtubeId}/maxresdefault.jpg` };
	}

	const boundingRegions = data.watch?.boundingRegions?.split?.(',').map(r => r.trim()).filter(r => r) || [];

	const landingPage = data.landingPage || 'about';
	const filmPageSubPath = landingPage === 'about' ? '/' : '/about-the-event/';
	const showtimesPageSubPath = landingPage === 'showtimes' ? '/' : '/tickets/';

	if (!data.enabled) return [{
		base: 'bolt',
		id: data.url,
		data: {
			disabledPage: true
		},
		type: 'filmPage',
		path: '/events/' + data.url + filmPageSubPath,
		customPageComponent: 'events'
	}];

	return [
		{
			base: 'bolt',
			id: data.url,
			// Ideally to avoid collision with group pages and regular pages, we should add some kind of prefix:
			// id: `event-${data.url}`,
			title: data.meta?.title,
			data: [
				{
					id: 'filmHero',
					component: 'heroSpot',
					data: {
						background: {
							alt: data.hero?.alt,
							desktop: data.hero?.img,
							mobile: data.hero?.mobileImg
						},
						buttons: (data.hero?.buttons?.length
							? (data.hero?.buttons?.map(button => getHeroButton(data, button)) ?? []).filter(b => b?.label)
							: [
								data.synopsis?.content && { label: 'Learn More', link: '#synopsis' },
								(data.watch?.showHomeEnt || data.watch?.showShowtimes) && { label: data.watch?.showShowtimes ? 'Now Showing' : 'Order Now', link: '#watch' }
							]
						).filter(button => button?.label),
						description: data.hero?.description,
						hasGradient: true,
						title: data.hero?.title,
						trailer: trailer ? { trailer } : null,
					},
				},
				data.synopsis?.content && {
					id: 'filmSynopsis',
					component: 'synopsis',
					data: {
						hash: 'synopsis',
						content: data.synopsis?.content,
						credits: data.synopsis?.credits?.map(e => ({ heading: e?.title, names: e?.content?.replace(/(^[^ ]|.[^ ]|[^ ].)\n/gm, '$1  \n') })).filter(e => e.names),
					},
				},
				data.promo && {
					id: 'promoBanner',
					component: 'toutVertical',
					data: {
						hash: 'promo',
						title: data.promo.title,
						description: data.promo.description,
						button: data.promo.button,
						path: data.promo.link,
						img: data.promo.img,
						alt: data.promo.alt,
					},
				},
			].filter(e => e),
			type: 'filmPage',
			path: '/events/' + data.url + filmPageSubPath,
			group: data.group,
			customPageComponent: 'events',
			customHeaderLogo: data.customHeaderLogo,
			customFooterLogo: data.customFooterLogo,
		},
		data.watch?.showShowtimes && {
			id: `${data.url}-showtimes`,
			type: 'showtimes',
			path: `/events/${data.url}${showtimesPageSubPath}`,
			data: {
				...appData?.pages?.boltShowtimes?.data,
				movieId: data.watch.movieId,
				boundingRegions: Object.fromEntries(boundingRegions.map(r => [r, true])),
				bg: { desktop: { asset: data.watch.onesheet }, mobile: { asset: data.watch.mobileOnesheet } },
			},
		}
	].filter(e => e);
}